import { render, staticRenderFns } from "./Disciplinary.vue?vue&type=template&id=20a0b3ef"
import script from "./Disciplinary.vue?vue&type=script&lang=js"
export * from "./Disciplinary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports